import { render } from "./pos-todo.vue?vue&type=template&id=131315f8"
import script from "./pos-todo.vue?vue&type=script&lang=js"
export * from "./pos-todo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__